import { createContext } from 'react';

import type {
  SeriesId,
  XYChartColorScale,
} from '../types/xy-chart-internals.js';

export type SeriesIdToColorScale = Map<SeriesId, XYChartColorScale>;

export const XYChartColorScalesContext = createContext<
  SeriesIdToColorScale | undefined
>(undefined);

XYChartColorScalesContext['displayName'] = 'XYChartColorScalesContext';
